var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "dropdowns-container" }, [
    _c("div", { staticClass: "dropdowns__item__wrapper" }, [
      _c("div", { staticClass: "dropdowns__item__wrapper__content" }, [
        _c(
          "div",
          { staticClass: "dropdowns__item__wrapper__content__title" },
          [
            _vm._t("default"),
            _c(
              "span",
              {
                staticClass: "txt",
                class: { "is-mobile": _vm.isMobile, up: _vm.open === "up" },
              },
              [_vm._v(_vm._s(_vm.$t(_vm.$capitalize(_vm.text))))]
            ),
          ],
          2
        ),
        _c(
          "ul",
          { class: _vm.open },
          _vm._l(_vm.options, function (option) {
            return _c(
              "li",
              {
                key: option.id,
                class: {
                  active: option.id === _vm.innerValue,
                  "is-mobile": _vm.isMobile,
                },
                on: {
                  click: function ($event) {
                    return _vm.selectOption(option)
                  },
                },
              },
              [
                option.id
                  ? _c("img", {
                      attrs: {
                        src: _vm.getFlagUrl(option.id),
                        width: "20",
                        height: "20",
                      },
                    })
                  : _vm._e(),
                _c("span", { staticClass: "country-label" }, [
                  _vm._v(_vm._s(_vm.$t(_vm.$capitalize(option.text)))),
                ]),
              ]
            )
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }